"use client";

import { cn } from "@saridana-core/react-ui-kit";
import { TCareerPointSection } from "@shared/types";
import Image from "next/image";

export function CareerPointSection({ title, points, showIcon }: TCareerPointSection) {
  const randomNumber = Math.random();

  return (
    <section className="bg-white">
      <div className="container relative lg:max-w-[872px] mx-auto  ">
        <h4 className="font-semibold text-2xl leading-[134%] mb-4">{title}</h4>
        <div className="text-lg text-gray-700">
          <ul className={cn(showIcon ? "space-y-3" : "list-disc ml-6")}>
            {points?.map((point, index) => (
              <li key={"point-" + randomNumber + index} className={cn(showIcon ? "flex items-center space-x-2" : "")}>
                {point?.icon && showIcon && (
                  <Image
                    src={point?.icon?.data?.attributes?.url || ""}
                    alt={point?.icon?.data?.attributes?.alternativeText || point?.icon?.data?.attributes?.name}
                    width={point?.icon?.data?.attributes?.width || 24}
                    height={point?.icon?.data?.attributes?.height}
                    className="size-6"
                  />
                )}
                <p>{point?.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
